import { SocialProfile } from "src/app/modals/AddSocialProfilesModal/AddSocialProfilesModal";
import { summaryPlacementOptions } from "src/app/CreatorShowcase/components/ShowcaseTemplate/tabs/ShowcaseCoverTab/components/SummaryPlacementSelector/summaryPlacementOptions";
import {
  CLEAR_SELECTED_CREATOR_DATA,
  CLEAR_SHOWCASE_DATA,
  GET_SHOWCASE_DATA_SUCCESS,
  SET_CREATORS_FOR_COVER,
  SET_GENERATING,
  SET_GRID_ELEMENTS,
  SET_HIDDEN_GRID_ELEMENTS,
  SET_LAYOUT,
  SET_MULTIPLE_LAYOUTS,
  SET_PRINTING,
  SET_SAVED_TEMPLATE,
  SET_SELECTED_CREATOR_DATA,
  SET_SELECTED_CREATORS,
  SET_SELECTED_TEMPLATE,
  SET_SHOWCASE_AUDIENCE_OVERLAP,
  SET_SHOWCASE_ELEMENTS,
  SET_SHOWCASE_TITLE,
  SET_SHOWCASE_TRANSITION,
  SET_STARTING_TEMPLATES,
  SET_SUMMARY_PLACEMENT,
  SET_TEMPLATE_BASE,
  SET_TEXT_SUMMARY,
} from "./showcaseTypes";
import { saveToLocalStorage } from "src/utils/localStorage";

export interface ShowcaseCreator {
  contextAttributeValues: { [key: string]: string | string[] | number };
  name: string;
  socialProfiles: SocialProfile[];
  socialProfilesData: { [key: string]: {} };
  uuid: string;
}

export type ShowcaseAudienceOverlapStatus = "off" | "pending" | "done";

export interface ShowcaseAudienceOverlapState {
  status: ShowcaseAudienceOverlapStatus;
  // boxes of the overlap section grouped into pages, built from the analysis result
  pages: any[];
  boxes: { [id: string]: any };
  // the last analysis of the current set of creators failed, so the next one must skip the cache
  retryWithForce: boolean;
  // increased with every new analysis or change of creators, lets ignore responses of outdated requests
  requestVersion: number;
}

export const initialShowcaseAudienceOverlap: ShowcaseAudienceOverlapState = {
  status: "off",
  pages: [],
  boxes: {},
  retryWithForce: false,
  requestVersion: 0,
};

const initialState = {
  showcaseData: {},
  selectedCreatorData: {},
  generating: true,
  printing: false,
  layout: [],
  savedTemplate: [],
  gridElements: [],
  hiddenGridElements: [],
  selectedCreators: [],
  multipleLayouts: [],
  selectedTemplate: { label: "Default", value: {} },
  startingTemplates: [],
  templateBase: [],
  showcaseTransition: null as number | null,
  previousCreatorId: null,
  creatorsForCover: [],
  textSummary: "Here you can add a creator summary",
  summaryPlacement:
    summaryPlacementOptions.find((option) => option.value === "bottom") ||
    summaryPlacementOptions[0],
  showcaseTitle: "Creator Showcase",
  audienceOverlap: initialShowcaseAudienceOverlap,
};

// eslint-disable-next-line @typescript-eslint/default-param-last
function showcaseReducer(state = initialState, action: any) {
  switch (action.type) {
    case GET_SHOWCASE_DATA_SUCCESS:
      return {
        ...state,
        showcaseData: action?.payload?.data?.content,
      };

    case CLEAR_SHOWCASE_DATA:
      return {
        ...state,
        showcaseData: {},
      };

    case CLEAR_SELECTED_CREATOR_DATA:
      return {
        ...state,
        selectedCreatorData: {},
      };

    case SET_SELECTED_CREATOR_DATA:
      return {
        ...state,
        selectedCreatorData: action.payload.selectedCreatorData,
      };

    case SET_GENERATING:
      return {
        ...state,
        generating: action.payload.generating,
      };

    case SET_PRINTING:
      return {
        ...state,
        printing: action.payload.printing,
      };

    case SET_LAYOUT:
      return {
        ...state,
        layout: action.payload.layout,
      };

    case SET_SAVED_TEMPLATE:
      return {
        ...state,
        savedTemplate: action.payload.savedTemplate,
      };

    case SET_GRID_ELEMENTS:
      return {
        ...state,
        gridElements: action.payload.gridElements,
      };

    case SET_HIDDEN_GRID_ELEMENTS:
      return {
        ...state,
        hiddenGridElements: action.payload.hiddenGridElements,
      };

    case SET_SELECTED_CREATORS:
      return {
        ...state,
        selectedCreators: action.payload.selectedCreators,
      };

    case SET_SHOWCASE_ELEMENTS:
      return {
        ...state,
        showcaseData: {
          ...state.showcaseData,
          elements: action.payload.elements,
        },
      };

    case SET_MULTIPLE_LAYOUTS:
      saveToLocalStorage(
        "showcaseMultipleLayouts",
        action.payload.multipleLayouts,
      );

      return {
        ...state,
        multipleLayouts: action.payload.multipleLayouts,
      };

    case SET_SELECTED_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload.selectedTemplate,
      };

    case SET_STARTING_TEMPLATES:
      return {
        ...state,
        startingTemplates: action.payload.startingTemplates,
      };

    case SET_TEMPLATE_BASE:
      return {
        ...state,
        templateBase: action.payload.templateBase,
      };

    case SET_SHOWCASE_TRANSITION:
      return {
        ...state,
        showcaseTransition: action.payload.showcaseTransition,
      };

    case SET_CREATORS_FOR_COVER:
      return {
        ...state,
        creatorsForCover: action.payload.creatorsForCover,
        creatorsForCoversInitiallySet: true,
      };

    case SET_TEXT_SUMMARY:
      return {
        ...state,
        textSummary: action.payload.textSummary,
      };

    case SET_SUMMARY_PLACEMENT:
      return {
        ...state,
        summaryPlacement: action.payload.summaryPlacement,
      };

    case SET_SHOWCASE_TITLE:
      return {
        ...state,
        showcaseTitle: action.payload.showcaseTitle,
      };

    case SET_SHOWCASE_AUDIENCE_OVERLAP:
      return {
        ...state,
        audienceOverlap: {
          ...state.audienceOverlap,
          ...action.payload.audienceOverlap,
        },
      };

    default:
      return state;
  }
}

export default showcaseReducer;
